export const BOOKS = [
  {
    slug: "baileys-affirmations",
    index: "01",
    title: "Bailey's Affirmations",
    ages: "Ages 1–10",
    price: 7.99,
    format: "Paperback",
    year: 2024,
    rating: 5.0,
    reviews: 3,
    badge: "Series favourite",
    cover: "/images/book-bailey-affirmations.jpg",
    asin: "106873258X",
    description:
      "Bailey's Children's Affirmation Book is a vibrant, uplifting guide designed to inspire young minds. Filled with colourful illustrations on every page, the book introduces positive affirmations that help boost children's self-esteem and confidence.",
    longDescription:
      "Each affirmation is paired with relatable characters, making the messages both fun and meaningful for young readers. A book families return to morning after morning — a gentle ritual of self-belief before the day begins.",
    themes: ["Self-belief", "Positive affirmations", "Daily confidence"],
    outcomes: [
      "Builds a daily habit of positive self-talk",
      "Grows self-esteem through repetition and rhythm",
      "Perfect for morning routines and bedtime reading",
    ],
  },
  {
    slug: "bailey-starts-school",
    index: "02",
    title: "Bailey Starts School",
    ages: "Ages 3–5",
    price: 9.99,
    format: "Paperback",
    year: 2025,
    rating: 5.0,
    reviews: 2,
    badge: "Back to school",
    cover: "/images/book-bailey-starts-school-new.jpeg",
    asin: "1068732563",
    description:
      "Step into Bailey's colourful world and discover the journey of a school day through the eyes of a happy little learner!",
    longDescription:
      "The perfect companion for any child about to take their first big step into the classroom. Bailey turns first-day nerves into wide-eyed excitement — making friends, meeting teachers, and discovering that school is a place where they belong.",
    themes: ["First day nerves", "New beginnings", "Friendship"],
    outcomes: [
      "Eases anxiety about starting school or nursery",
      "Introduces the rhythm of a happy school day",
      "Encourages conversation about feelings and new experiences",
    ],
  },
  {
    slug: "bailey-visits-the-dentist",
    index: "03",
    title: "Bailey Visits the Dentist",
    ages: "Ages 3–8",
    price: 9.99,
    format: "Paperback",
    year: 2025,
    rating: 5.0,
    reviews: 4,
    badge: null,
    cover: "/images/book-bailey-dentist.jpg",
    asin: "1068732571",
    description:
      "A dental journey adventure about a young boy's story of his first dental appointment — from a healthy breakfast and brushing his teeth, to sitting in the dental chair and discovering the fun water jet used by Dr Dentist.",
    longDescription:
      "Written to take the fear out of that very first check-up, Bailey shows little readers exactly what to expect — and that the dentist's chair can be an adventure, not a worry.",
    themes: ["Healthy habits", "Big firsts", "Bravery"],
    outcomes: [
      "Prepares children for their first dental appointment",
      "Reinforces tooth-brushing and healthy routines",
      "Turns a scary milestone into a shared adventure",
    ],
  },
  {
    slug: "bailey-what-can-you-do",
    index: "04",
    title: "Bailey, What Can You Do?",
    ages: "Ages 3–7",
    price: 9.99,
    format: "Paperback",
    year: 2024,
    rating: 5.0,
    reviews: 10,
    badge: "Most loved",
    cover: "/images/book-bailey-what-can-you-do.jpeg",
    asin: "1068732598",
    description:
      "Captures 'all the things' a young boy with a bright smile can do. Each day, Bailey discovers new developments at home — a relatable story celebrating early independence for young children to follow.",
    longDescription:
      "The most-reviewed book in the series. A joyful roll-call of small victories — getting dressed, helping at home, trying again — that shows children their growing independence is something to be proud of.",
    themes: ["Independence", "Everyday wins", "Growing up"],
    outcomes: [
      "Celebrates early-years independence milestones",
      "Encourages 'I can do it myself' confidence",
      "Relatable everyday moments spark real conversations",
    ],
  },
  {
    slug: "bailey-in-london",
    index: "05",
    title: "Bailey in London",
    ages: "Ages 3–10",
    price: 14.99,
    format: "Paperback",
    year: 2026,
    rating: null,
    reviews: 0,
    badge: "Available now",
    cover: "/images/book-bailey-in-london.jpeg",
    asin: "1068732555",
    description:
      "Discover London with Bailey! The perfect sightseeing companion for young explorers — journey through the bustling streets of London, spotting famous landmarks and riding red buses and taxis along the way.",
    longDescription:
      "This delightful tour guide sparks curiosity, supports early learning, and brings the vibrancy of London to life for curious minds. Bonus fun inside: a handy guide to London's famous attractions with Underground stations and Tube lines to help you find them, plus a finger maze on the back page and a London-themed board game to enjoy.",
    themes: ["Curiosity", "Adventure", "The world around us"],
    outcomes: [
      "Introduces famous London landmarks through story",
      "Includes a guide to attractions, Tube lines, a finger maze and a board game",
      "A keepsake for families visiting or exploring from home",
    ],
  },
];

export const amazonUrl = (book) => `https://www.amazon.co.uk/dp/${book.asin}`;

export const formatPrice = (n) => `£${n.toFixed(2)}`;
